export default "__VITE_ASSET__Br_JIZcx__"